import React, { useContext } from "react";
import AnalyticsHubReport from "../../components/power-bi/AnalyticsHubReport";
import { AnalyticsHubContext } from "../../contexts/AnalyticsHubContext";
import useReloadOnPropertyChange from "../../hooks/useReloadOnPropertyChange";
import "./analyticsHub.scss";

const Summary = () => {
  const { setPages } = useContext(AnalyticsHubContext);

  useReloadOnPropertyChange();

  return (
    <div className="analytics-hub-page">
      <AnalyticsHubReport pageName="Summary" onPagesLoaded={setPages} />
    </div>
  );
};

export default Summary;
